module.exports = __webpack_public_path__ + "static/img/1.cb07d147.png";